import { formatDate } from '@angular/common';

// Carimbos gravados pelo servidor (criação do lote, envio de e-mail, início da execução etc.) chegam
// com a hora do servidor e sem indicação de fuso: em hml/produção o servidor roda em UTC; numa máquina
// local roda no fuso do próprio computador. O backend informa o deslocamento dele (GET system/time-info)
// e aqui convertemos para Brasília (UTC-3, sem horário de verão), onde o usuário opera.
// Datas de negócio digitadas pelo usuário (pagamento, previsão) NÃO passam por aqui.
const BRASILIA_OFFSET = '-0300';
const HAS_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/i;

// Enquanto não carregado, assume servidor em UTC (hml/produção).
let serverUtcOffsetMinutes = 0;

export function setServerUtcOffsetMinutes(minutes: number): void {
  serverUtcOffsetMinutes = Number.isFinite(minutes) ? minutes : 0;
}

export function getServerUtcOffsetMinutes(): number {
  return serverUtcOffsetMinutes;
}

function isServerDateTime(value: string | Date): value is string {
  return typeof value === 'string' && value.includes('T') && !HAS_OFFSET.test(value);
}

// Instante real (independente de fuso) de um carimbo do servidor: hora gravada - deslocamento do servidor.
export function parseSystemInstant(value: string | Date): Date {
  if (isServerDateTime(value)) {
    return new Date(Date.parse(`${value}Z`) - serverUtcOffsetMinutes * 60000);
  }

  return new Date(value);
}

export function formatSystemDate(
  value: string | Date | null | undefined,
  format = 'dd/MM/yyyy'
): string | null {
  if (!value) return null;

  if (!isServerDateTime(value)) {
    return formatDate(value, format, 'pt-BR', BRASILIA_OFFSET);
  }

  return formatDate(parseSystemInstant(value), format, 'pt-BR', BRASILIA_OFFSET);
}
